import EventBus from '@/js/util/EventBus'

export default {
  props: {
    videoId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isPlaying: true,
    }
  },

  render(createElement) {
    const { isPlaying } = this
    const elementData = {
      class: isPlaying,
      on: {
        click: () => {
          this.isPlaying = !this.isPlaying
          EventBus.$emit('toggle', this.videoId)
        },
      },
    }
    return createElement('button', elementData, this.$scopedSlots.default({ isPlaying }))
  },
}




// WEBPACK FOOTER //
// ./src/js/components/SilentVideoButton.js